import _possibleConstructorReturn from "/home/signin/web-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/signin/web-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/signin/web-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/signin/web-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/signin/web-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
 * Copyright (C) 2016 Bilibili. All Rights Reserved.
 *
 * @author zheng qian <xqq@xqq.im>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var RuntimeException =
/*#__PURE__*/
function () {
  function RuntimeException(message) {
    _classCallCheck(this, RuntimeException);

    this._message = message;
  }

  _createClass(RuntimeException, [{
    key: "toString",
    value: function toString() {
      return this.name + ': ' + this.message;
    }
  }, {
    key: "name",
    get: function get() {
      return 'RuntimeException';
    }
  }, {
    key: "message",
    get: function get() {
      return this._message;
    }
  }]);

  return RuntimeException;
}();
export var IllegalStateException =
/*#__PURE__*/
function (_RuntimeException) {
  _inherits(IllegalStateException, _RuntimeException);

  function IllegalStateException(message) {
    _classCallCheck(this, IllegalStateException);

    return _possibleConstructorReturn(this, _getPrototypeOf(IllegalStateException).call(this, message));
  }

  _createClass(IllegalStateException, [{
    key: "name",
    get: function get() {
      return 'IllegalStateException';
    }
  }]);

  return IllegalStateException;
}(RuntimeException);
export var InvalidArgumentException =
/*#__PURE__*/
function (_RuntimeException2) {
  _inherits(InvalidArgumentException, _RuntimeException2);

  function InvalidArgumentException(message) {
    _classCallCheck(this, InvalidArgumentException);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidArgumentException).call(this, message));
  }

  _createClass(InvalidArgumentException, [{
    key: "name",
    get: function get() {
      return 'InvalidArgumentException';
    }
  }]);

  return InvalidArgumentException;
}(RuntimeException);
export var NotImplementedException =
/*#__PURE__*/
function (_RuntimeException3) {
  _inherits(NotImplementedException, _RuntimeException3);

  function NotImplementedException(message) {
    _classCallCheck(this, NotImplementedException);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotImplementedException).call(this, message));
  }

  _createClass(NotImplementedException, [{
    key: "name",
    get: function get() {
      return 'NotImplementedException';
    }
  }]);

  return NotImplementedException;
}(RuntimeException);